import { MapContainer, TileLayer, Marker, Polyline, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (label, color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;width:24px;height:24px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center"><span style="transform:rotate(45deg);font-size:11px;font-weight:700">${label}</span></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 24],
});

// Leaflet map of the driver's ordered stops for the day, with the laundry HQ as the start.
export default function DriverRouteMap({ start, stops }) {
  const located = (stops || []).filter((s) => s.coords);
  const pts = [];
  if (start) pts.push(start);
  located.forEach((s) => pts.push(s.coords));
  if (!pts.length) {
    return <div className="mt-3 rounded-xl border border-dashed border-white/10 p-4 text-center text-xs text-slate-500" data-testid="driver-route-map-empty">Map unavailable for today&rsquo;s addresses.</div>;
  }
  const lat = pts.reduce((s, p) => s + p[0], 0) / pts.length;
  const lng = pts.reduce((s, p) => s + p[1], 0) / pts.length;

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-white/10" data-testid="driver-route-map">
      <MapContainer center={[lat, lng]} zoom={12} style={{ height: 240, width: "100%" }} scrollWheelZoom={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        {start && <Marker position={start} icon={pin("HQ", "#0EA5A4")}><Tooltip>Your laundry</Tooltip></Marker>}
        {located.map((s) => (
          <Marker key={s.id} position={s.coords} icon={pin(String(s.seq), "#F59E0B")}>
            <Tooltip>{s.seq}. {s.client_name} · {s.type}</Tooltip>
          </Marker>
        ))}
        {pts.length > 1 && <Polyline positions={pts} pathOptions={{ color: "#0EA5A4", weight: 3, opacity: 0.7 }} />}
      </MapContainer>
    </div>
  );
}
